<template lang="pug">
.register-row.form-label
  .register-group
    .register-key
      span.key-name {{ keyName }}
    .register-value(v-if="value")
      span.text(v-text="_value")
    .register-value(v-else)
      span.error-message 未設定
    .register-value
      slot(name="textOption")
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ラベルのみコンポーネント
 *
 * - ラベルと値を表示するのみ
 * - 入力要素コンポーネントと同じレイアウトをサポートする
 */
@Component
export default class FormLabel extends Vue {
  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: any;

  /** 項目名 */
  @Prop({ required: true, type: String })
  keyName!: string;

  get _value(): string {
    return this.value;
  }
}
</script>

<style lang="scss" scoped>
.form-label {
  .text {
    white-space: pre-wrap;
    word-wrap: break-word;
    margin: 0 !important;
  }
  .error-message {
    margin: 0px !important;
  }
}
</style>
